/* global window */
'use strict';

module.exports = require('./ponyfill')(global || window || this);



//////////////////
// WEBPACK FOOTER
// ./node_modules/is-observable/node_modules/symbol-observable/index.js
// module id = 339
// module chunks = 0